import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';
import {format, timezoneName} from '../utils/date';


export const selectMeetingDateTime = (
  state: IRootMachineSnapshot,
  language: string,
) => {
  if (!state.context.eventDetails?.event_start) {
    return '';
  }
  const dateTime = format(
    new Date(state.context.eventDetails?.event_start),
    'PPPPp',
    {language},
  );
  const timezone =
    timezoneName(state.context.eventDetails?.event_start, language) || '';

  return `${dateTime}, ${timezone}`;
};
